import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';
import TEAM_MEMBERS from '../teamMembers.config';
import TEAM_MEMBER_BIOS from '../teamMemberBios.config';
import { FeaturedTeamMember, FeaturedTeamMemberWithBio } from '../teamMembers.types';
import TeamCard from './TeamCard.vue';
import TeamBioPopup from './TeamBioPopup.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamGrid',
  setup(__props) {

const featuredTeamMembers = computed(() => TEAM_MEMBERS.filter((e): e is FeaturedTeamMember => e.kind === 'featured'));

const bioByName = computed(() => new Map(TEAM_MEMBER_BIOS.map((entry) => [entry.name, entry])));

const sortedTeamMembers = computed(() => {
  const teamMembers = featuredTeamMembers.value.map((member) => ({
    ...member,
    bio: bioByName.value.get(member.name),
  }));
  return teamMembers.sort((a, b) => a.position - b.position);
});

const selectedTeamMember = ref<FeaturedTeamMemberWithBio | null>(null);

function openBio(teamMember: FeaturedTeamMemberWithBio): void {
  if (teamMember.bio?.use !== 1) return;
  selectedTeamMember.value = teamMember;
}

function closeBio(): void {
  selectedTeamMember.value = null;
}

function handleKeydown(event: KeyboardEvent): void {
  if (event.key === 'Escape') closeBio();
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown);
});

return { __sfc: true,featuredTeamMembers, bioByName, sortedTeamMembers, selectedTeamMember, openBio, closeBio, handleKeydown, TeamCard, TeamBioPopup }
}

})